module.exports = __webpack_public_path__ + "img/15-half-lg.ccf60918.jpg";